/*
 * @LastEditors: zl
 * @Date: 2025-05-16 10:59:01
 * @LastEditTime: 2025-05-16 11:01:13
 * @Email: 
 * @Description: 
 */
const meta = { auth: true }
export const bllc = {
  path: '/processMap',
  name: 'processMap',
  component: () => import('@/pages/guide/processMap.vue'),
  meta: {
    ...meta,
    title: '业务办理流程',
    // requireAuth: true
  }
}
export const czxx = {
  path: '/stationBasicInfo',
  name: 'stationBasicInfo',
  component: () => import('@/pages/guide/stationBasicInfo.vue'),
  meta: {
    ...meta,
    title: '车站基本信息',
    // requireAuth: true
  }
}
export const yfcx = {
  path: '/freightInquiry',
  name: 'freightInquiry',
  component: () => import('@/pages/transportService/freightInquiry.vue'),
  meta: {
    ...meta,
    title: '运费查询',
    requireAuth: true
  }
}